import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api, formatErr } from "@/lib/api";
import { Ladybug } from "@/components/site/Ladybug";

const KEY = "th_tea_seen";

const TeaForm = ({ onDone }) => {
  const [form, setForm] = useState({ first_name: "", email: "", phone: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/subscribe", form);
      onDone(data.message);
    } catch (err) {
      setError(formatErr(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <form onSubmit={submit} className="space-y-4 mt-6" data-testid="tea-form">
      <input required placeholder="First name" className="field" value={form.first_name} onChange={set("first_name")} data-testid="tea-name-input" />
      <input required type="email" placeholder="Email" className="field" value={form.email} onChange={set("email")} data-testid="tea-email-input" />
      <input placeholder="Phone number (optional)" className="field" value={form.phone} onChange={set("phone")} data-testid="tea-phone-input" />
      {error && <p className="text-sm text-[#9c3d5c]" data-testid="tea-error">{error}</p>}
      <button disabled={busy} className="btn btn-olive w-full" data-testid="tea-submit-btn">{busy ? "Steeping…" : "Pour Me a Cup"} <Ladybug size={16} rotate={20} /></button>
    </form>
  );
};

export const TeaPopup = () => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [done, setDone] = useState("");

  useEffect(() => {
    const show = () => { setDone(""); setOpen(true); };
    window.addEventListener("open-tea", show);
    const quiet = ["/admin", "/ambassadors", "/apply", "/reset-password", "/members"].some((p) => pathname.startsWith(p));
    const t = !localStorage.getItem(KEY) && !quiet ? setTimeout(show, 8000) : null;
    return () => { window.removeEventListener("open-tea", show); if (t) clearTimeout(t); };
  }, [pathname]);

  const change = (v) => {
    setOpen(v);
    if (!v) localStorage.setItem(KEY, "1");
  };

  return (
    <Dialog open={open} onOpenChange={change}>
      <DialogContent data-testid="tea-popup" className="p-0 overflow-hidden max-w-3xl w-[94vw] max-h-[92vh] overflow-y-auto bg-[#faf7f2] border-[#dacac1] rounded-3xl grid md:grid-cols-2 gap-0">
        <img src="/img/tea.jpg" alt="A woman at peace sipping tea beside Palo Santo smoke" className="w-full h-56 md:h-full object-cover" />
        <div className="relative p-8 sm:p-10">
          <Ladybug spot="tr" size={20} rotate={-30} className="!right-12" />
          {done ? (
            <div data-testid="tea-success" className="py-10">
              <DialogTitle className="font-serif-h text-4xl font-light text-[#577731]">Your cup is poured.</DialogTitle>
              <DialogDescription className="mt-4 text-[#232b1b]/75 leading-relaxed">{done}</DialogDescription>
              <button onClick={() => change(false)} className="btn btn-ghost mt-8" data-testid="tea-close-btn">Return to the Circle</button>
            </div>
          ) : (
            <>
              <DialogTitle className="font-serif-h text-3xl sm:text-4xl font-light text-[#577731] leading-tight">Subscribe to Get the Tea Weekly</DialogTitle>
              <DialogDescription className="mt-4 text-sm text-[#232b1b]/75 leading-relaxed">
                Pull up a chair, beloved. Every week we pour you a fresh cup: healing wisdom, seasonal rituals, ceremony invitations, and first word on new medicine from The Healers Market. Sacred, never spammy.
              </DialogDescription>
              <TeaForm onDone={(m) => { setDone(m); localStorage.setItem(KEY, "1"); }} />
            </>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
